export default __webpack_public_path__ + "static/media/ic_square.c7ab50639dc7eb2ca466c5b67ea6c9c3.svg";